<template>
<div class="chapter">
<div class="inner_page">
<div class="dedicationPage">
<a id="title17"></a>
<div class="p-c"><span><em class="i">To my darling wife, Debbie, whose love has nourished and sustained me for longer than I can remember. We are together, eternally.</em></span></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9780312964139_ded01.vue?7a8ae414